import { useState } from 'react'
import { Grid } from '@mui/material'

import GridSelect from './GridSelect'
import GridIconButton from './GridIconButton'
import GridInputField from './GridInputField'
import { SESSI } from '../settings/settings'

const GridCategoryRequirement = ({ values, onChange = () => {} }) => {
  const [newRequirement, setNewRequirement] = useState()

  const cSetNewRequirement = (field, value) =>
    setNewRequirement({ ...newRequirement, [field]: value })

  const addRequirement = () => {
    onChange((values || [])?.concat(newRequirement))
    setNewRequirement()
  }

  if (!newRequirement)
    return (
      <GridIconButton
        type='add'
        size={12}
        noCenter
        iconSize='small'
        onClick={() => setNewRequirement({})}
        text='Nuovo'
      />
    )

  return (
    <Grid container spacing={2} alignItems='center' sx={{ width: '100%' }}>
      <GridInputField
        label='Dal'
        field='annoMin'
        value={newRequirement?.annoMin}
        onChange={cSetNewRequirement}
        type='number'
      />
      <GridInputField
        label='Al'
        field='annoMax'
        value={newRequirement?.annoMax}
        onChange={cSetNewRequirement}
        type='number'
      />
      <GridSelect
        label='Sesso'
        field='sesso'
        value={newRequirement?.sesso}
        onChange={cSetNewRequirement}
        options={SESSI?.map(x => x.key)}
        optionLabels={SESSI?.map(x => x.label)}
      />
      <GridIconButton
        type='save'
        size={{ xs: 6, md: 3 }}
        onClick={addRequirement}
      />
      <GridIconButton
        type='clear'
        size={{ xs: 6, md: 3 }}
        onClick={() => setNewRequirement()}
      />
    </Grid>
  )
}

export default GridCategoryRequirement
